export default __webpack_public_path__ + "static/media/starling.fc0e548b.png";